import { render, staticRenderFns } from "./fillTagsImagesPopup.vue?vue&type=template&id=56fc9d6a"
import script from "./fillTagsImagesPopup.vue?vue&type=script&lang=js"
export * from "./fillTagsImagesPopup.vue?vue&type=script&lang=js"
import style0 from "./fillTagsImagesPopup.vue?vue&type=style&index=0&id=56fc9d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports